import { createAction } from 'redux-starter-kit';


export const putDashboardData = createAction('PUT_DASHBOARD_DATA');
export const updateRateData = createAction('UPDATE_DASHBOARD_RATE_DATA');
export const updateReasonData = createAction('UPDATE_DASHBOARD_REASON_DATA');
export const updateIssueData = createAction('UPDATE_DASHBOARD_ISSUE_DATA');
